<script>
export default {
    name: "Stamp",
    data(){
        return{
            companyUrl:this.$root.companydetails.stampUrl,
        }
    }
}
</script>
<template>
    <div class="w-full -mt-20" >
        <div class="flex items-center justify-center ml-36 pb-2" ><img :src="companyUrl"></div> 

    </div>
    
</template>


